import { Callout } from "$components/callout";
import { useServerTime } from "$global-providers/server-time-provider/provider";
import type { CurrencyExchangeRate } from "$routes/_lib/billing-v2/currency-exchange";
import { useCurrencyExchangeFormat } from "$routes/_lib/use-currency-exchange-format";
import { isExchangeRateStale } from "$routes/patient/[:patientId]/_lib/invoices-v2/use-latest-exchange-rate";
import { Box, Typography } from "@material-ui/core";
import { format, parseISO } from "date-fns";
import { FormattedMessage, useIntl } from "react-intl";

export const ExchangeRateNote = ({ rate }: { rate: CurrencyExchangeRate }) => {
  const { formatMessage } = useIntl();
  const { formatRate } = useCurrencyExchangeFormat();
  const { getDisplayTime } = useServerTime();

  return (
    <Box>
      <Typography
        variant="body2"
        color="textSecondary"
        data-testid="invoicing.exchangeRate"
      >
        <FormattedMessage
          id="invoicing.exchangeRate"
          defaultMessage="Exchange rate {rate}, published {date}"
          values={{
            rate: formatRate(rate),
            date: format(parseISO(rate.effectiveDate), "dd MMM yyyy"),
          }}
        />
      </Typography>
      {isExchangeRateStale(rate.effectiveDate, getDisplayTime()) && (
        <Box mt={1}>
          <Callout
            type="warning"
            title={formatMessage({
              id: "invoicing.exchangeRate.stale.title",
              defaultMessage: "This exchange rate is out of date",
            })}
            data-testid="invoicing.exchangeRate.stale"
          >
            <FormattedMessage
              id="invoicing.exchangeRate.stale.body"
              defaultMessage="It is more than 2 days old. Check it before taking the money."
            />
          </Callout>
        </Box>
      )}
    </Box>
  );
};
